import { ProductMerchantModel } from '../models/productMerchant';
import axios from '../lib/axios';
import {
  PRODUCT_FIND_MANY,
  PRODUCT_GET_COUNT_MERCHANT_PRODUCT,
  SEARCH_PRODUCT_MERCHANT,
  UPDATE_PRODUCT_MERCHANT,
} from '../lib/endpoints/product';
import { concatenateStrings } from '../utils/concatenateStrings';

interface InputGetProductMerchantProps {
  take: number;
  skip?: number;
  productMainGroupId?: string;
  productDivisionNameId?: string;
  productCategoryId?: string;
  productSubCategoryId?: string;
  merchantId: string;
  recommend?: boolean;
  productNew?: boolean;
}

interface InputCategoryValue {
  mainId?: string;
  divisionId?: string;
  categoryId?: string;
  subCategoryId?: string;
  merchantId?: string;
  take?: number;
  skip?: number;
}

export const getProductMerchant = async ({
  take,
  skip,
  productMainGroupId,
  productDivisionNameId,
  productCategoryId,
  productSubCategoryId,
  merchantId,
  recommend,
  productNew,
}: InputGetProductMerchantProps): Promise<ProductMerchantModel[]> => {
  let filtter: any = {};
  if (productMainGroupId) {
    filtter.productMainGroupId = productMainGroupId;
  }
  if (productDivisionNameId) {
    filtter.productDivisionNameId = productDivisionNameId;
  }
  if (productCategoryId) {
    filtter.productCategoryId = productCategoryId;
  }
  if (productSubCategoryId) {
    filtter.productSubCategoryId = productSubCategoryId;
  }
  if (merchantId) {
    filtter.merchantId = merchantId;
  }
  if (recommend) {
    filtter.recommend = recommend;
  }
  if (recommend) {
    filtter.productNew = productNew;
  }
  const [resProducts] = await Promise.all([
    axios.post(PRODUCT_FIND_MANY, {
      filtter,
      take,
      skip,
    }),
  ]);
  return resProducts?.data;
};

export const handleGetProductMerchantByCategory = async ({
  mainId,
  divisionId,
  categoryId,
  subCategoryId,
  merchantId,
  take,
  skip,
}: InputCategoryValue): Promise<ProductMerchantModel[]> => {
  const filtter = {
    ...(mainId !== 'All' && { productMainGroupId: mainId, merchantId: merchantId }),
    ...(divisionId !== 'All' && { productDivisionNameId: divisionId, merchantId: merchantId }),
    ...(categoryId !== 'All' && { productCategoryId: categoryId, merchantId: merchantId }),
    ...(subCategoryId !== 'All' && { productSubCategoryId: subCategoryId, merchantId: merchantId }),
  };
  console.log(filtter);

  const { data: resData } = await axios.post(PRODUCT_FIND_MANY, {
    filtter,
    take,
    skip,
  });

  return resData;
};

export const getCountProductMerchant = async ({
  merchantId,
}: {
  merchantId: string;
}): Promise<number> => {
  const resGetCountAllProduct = await axios.post(
    PRODUCT_GET_COUNT_MERCHANT_PRODUCT + `?merchantId=${merchantId}`
  );
  return resGetCountAllProduct?.data?.data?.All?._all;
};

export const handleSearchProductMerchantByItemCode = async ({
  searchValue,
  merchantId,
}: {
  searchValue: string;
  merchantId: string;
}) => {
  const res = await axios.post(PRODUCT_FIND_MANY, {
    filtter: {
      merchantId: merchantId,
      itemcode: searchValue,
    },
  });

  return res?.data;
};

export const handleSearchProductMerchant = async (
  searchValue: string,
  merchantId: string
): Promise<ProductMerchantModel[]> => {
  try {
    const res = await axios.post(
      `${SEARCH_PRODUCT_MERCHANT}?merchantId=${merchantId}&name=${searchValue}`
    );

    if (Array.isArray(res.data) && res.data.length === 0) {
      return await handleSearchProductMerchantByItemCode({
        searchValue: searchValue,
        merchantId: merchantId,
      });
    }

    return res.data;
  } catch (err) {
    console.error('Error fetching products:', err);
    throw err;
  }
};

export const getProductMerchantById = async (
  id: string,
  merchantId: string
): Promise<ProductMerchantModel[]> => {
  const res = await axios.post(PRODUCT_FIND_MANY, {
    filtter: {
      id: id,
      merchantId: merchantId,
    },
  });
  console.log(res?.data);
  
  return res?.data;
};

export const getMultipleProductMerchant = async (
  ids: string[],
  merchantId: string
): Promise<ProductMerchantModel[]> => {
  try {
    const results = await Promise.all(
      ids.map(async (id) => {
        return getProductMerchantById(id, merchantId);
      })
    );
    // Flatten the array of arrays returned by Promise.all into a single array
    return results.flat();
  } catch (error) {
    throw error;
  }
};

export const updateProductMerchantById = async (
  id: string,
  merchantCode: string
): Promise<void> => {
  try {
    const queryParams: Record<string, string> = {};
    if (id) queryParams.merchantId = id;
    if (merchantCode) queryParams.merchantCode = merchantCode;
    const queryString = new URLSearchParams(queryParams).toString();
    const apiEndpoint = UPDATE_PRODUCT_MERCHANT + (queryString ? `?${queryString}` : '');
    const res = await axios.get(apiEndpoint);
    console.log(res?.data);
    return res?.data;
  } catch (error) {
    throw error;
  }
};
